import { Divider, Heading, Modal } from '@zillow/constellation-10';
import { ZDocsEditor } from '@zillow/zdocs-web';

type ProofOfInsuranceViewerProps = {
  isOpen: boolean;
  onClose: () => void;
  previewUrl: string | null;
  title: string;
};

const ProofOfInsuranceViewer = ({ isOpen, onClose, previewUrl, title }: ProofOfInsuranceViewerProps) => {
  return (
    <Modal.Root
      size="fullScreen"
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <Modal.Portal>
        <Modal.Backdrop>
          <Modal.Content>
            <Modal.Header>
              <Heading level={1}>{title}</Heading>
            </Modal.Header>
            <Divider />
            <Modal.Body css={{ padding: '0 !important' }}>{previewUrl && <ZDocsEditor url={previewUrl} />}</Modal.Body>
            <Modal.CloseButton />
          </Modal.Content>
        </Modal.Backdrop>
      </Modal.Portal>
    </Modal.Root>
  );
};

export default ProofOfInsuranceViewer;
